import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-598d352a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.species), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.breed), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.gender), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.birth), 1)
    ]),
    _createElementVNode("td", null, [
      (_ctx.ageYears == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.ageYears) + " " + _toDisplayString(_ctx.$t('General.Year')), 1))
        : _createCommentVNode("", true),
      (_ctx.ageYears > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.ageYears) + " " + _toDisplayString(_ctx.$t('General.Years')), 1))
        : _createCommentVNode("", true),
      (_ctx.ageMonths == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.ageMonths) + " " + _toDisplayString(_ctx.$t('General.Month')), 1))
        : _createCommentVNode("", true),
      (_ctx.ageMonths > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.ageMonths) + " " + _toDisplayString(_ctx.$t('General.Months')), 1))
        : _createCommentVNode("", true),
      (_ctx.ageYears == 0 && _ctx.ageMonths == 0 && _ctx.ageDays == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.ageDays) + " " + _toDisplayString(_ctx.$t('General.Day')), 1))
        : _createCommentVNode("", true),
      (_ctx.ageYears == 0 && _ctx.ageMonths == 0 && _ctx.ageDays > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.ageDays) + " " + _toDisplayString(_ctx.$t('General.Days')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.fertile_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.petData.weight), 1)
    ]),
    (_ctx.considerInsurance)
      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
          _createElementVNode("div", null, _toDisplayString(_ctx.petData.policy), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.getAccessType == 'manager')
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          class: _normalizeClass({ 'inactive-status': _ctx.petData.status === _ctx.$t('PetData.TK_Inactive') })
        }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.petData.status), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.getAccessType == 'manager')
      ? (_openBlock(), _createElementBlock("td", {
          key: 2,
          class: _normalizeClass({ 'inactive-status': _ctx.petData.status === _ctx.$t('PetData.TK_Inactive') })
        }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.petData.status_date), 1)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          (!_ctx.getEditedCustEditingPet &&
                _ctx.getEditingCustomer &&
                !_ctx.getShowingPetRecord &&
                (_ctx.getAccessType == 'manager'  || _ctx.petData.pet_id == 0))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "button is-warning is-small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.iniEditing(_ctx.petData))),
                disabled: _ctx.petData.status === _ctx.$t('PetData.TK_Inactive')
              }, _toDisplayString(_ctx.$t('General.Edit')), 9, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.getEditedCustEditingPet &&
                 _ctx.getEditingCustomer &&
                 !_ctx.getShowingPetRecord &&
                 (_ctx.getAccessType == 'manager'  || _ctx.petData.pet_id == 0) &&
                 _ctx.petData.status !== _ctx.$t('PetData.TK_Inactive'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-danger is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remove(_ctx.petData, _ctx.$t)))
              }, _toDisplayString((_ctx.getAccessType === 'manager' && _ctx.petData.pet_id != 0)
              ? _ctx.$t('General.Deactivate')
              : _ctx.$t('General.Delete')), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.getEditedCustEditingPet &&
                 _ctx.getEditingCustomer &&
                 !_ctx.getShowingPetRecord &&
                 _ctx.getAccessType == 'manager' &&
                 _ctx.petData.status !== _ctx.$t('PetData.TK_Active'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-warning is-small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reactivate(_ctx.petData, _ctx.$t)))
              }, _toDisplayString(_ctx.$t('General.Reactivate')), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.getEditingCustomer && !_ctx.getShowingPetRecord)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-warning is-small",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.iniRecord(_ctx.petData)))
              }, _toDisplayString(_ctx.$t('General.Record')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}